import { SMITE_GIVEAWAY_BANNER_HEADER_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import smiteGiveaway from 'root/src/client/public/smite-giveaway.png'

export default {
	[SMITE_GIVEAWAY_BANNER_HEADER_MODULE_ID]: {
		moduleType: 'bannerHeader',
		bannerImage: smiteGiveaway,
	},
}
